module.exports = __webpack_public_path__ + "img/ug.3cf8a285.jpg";